import { SOAP_COMMENT_FORMAT } from 'src/constants';
import { MemoCategoryKey, SoapCommentsKey } from 'src/types';
import { isClinic } from './client';
export var getConsultationTreatmentWording = function getConsultationTreatmentWording(key) {
  switch (key) {
    case 'soapRecordText':
      return isClinic() ? 'common:normal.consultation_and_treatment' : 'common:normal.analysis_records';

    case 'bookingItemText':
      return isClinic() ? 'booking:sb_booking_item' : 'common:normal.booking_item';

    case 'bookingPrincipalText':
      return isClinic() ? 'booking:sb_booking_item' : 'common:normal.principal';

    case 'pre_rd_comment':
    case SoapCommentsKey.pre_rd_comments:
      return isClinic() ? 'common:tab.pre_rd_comment' : 'common:normal.analysis_records';

    default:
      return key;
  }
};
export var getPdfSoapCommentWording = function getPdfSoapCommentWording(key) {
  return isClinic() ? SOAP_COMMENT_FORMAT[key].text : SOAP_COMMENT_FORMAT[key].textConsult || SOAP_COMMENT_FORMAT[key].text;
};
export var getSoapCommentWording = function getSoapCommentWording(key) {
  return isClinic() ? SOAP_COMMENT_FORMAT[key].i18n : SOAP_COMMENT_FORMAT[key].i18nConsult || SOAP_COMMENT_FORMAT[key].i18n;
};
export var getMemoCategoryWording = function getMemoCategoryWording(key) {
  switch (key) {
    case MemoCategoryKey.return_appointment_info_handover:
      return isClinic() ? MemoCategoryKey[key] : 'hq_return_appointment_info_handover';

    default:
      return MemoCategoryKey[key];
  }
};
export var getHandoverWording = function getHandoverWording(key) {
  switch (key) {
    case 'common:normal.remark':
      return isClinic() ? key : 'common:hq_returnVisitHandover';

    case 'common:enterConsultationPage':
      return isClinic() ? key : 'common:hq_enterConsultationPage';

    default:
      return key;
  }
};